import { render, staticRenderFns } from "./ModuleContentComponent.vue?vue&type=template&id=4e8f16f1"
import script from "./ModuleContentComponent.vue?vue&type=script&lang=js"
export * from "./ModuleContentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports